<template>
  <div class="actions-in-row">
    <v-tooltip top v-if="!hideView && permissions.scheduler.actions.view">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click.native="$emit('view', schedule)">
          <v-icon>mdi-eye-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.scheduler.actions.view }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.scheduler.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click="$emit('edit', schedule)">
          <v-icon>mdi-account-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.scheduler.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.scheduler.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click="delete_(schedule)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.scheduler.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import scheduler from '../../mixins/index'

export default {
  mixins: [ appdata, scheduler ],
  props: {
    schedule: Object,
    hideView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
